export const userTransactionSummaries = {
    totalDepositAmount: "Total Deposit Amount",
    totalDepositCount: "Total Deposit Count",
    totalWithdrawAmount: "Total Withdraw Amount",
    totalWithdrawCount: "Total Withdraw Count",
};
